<div class="wrapper">
    <div class="abs-center">
        <!-- START card-->
        <div class="text-center mb-4">
            <div class="text-lg mb-3">
                <em class="icon icon-support fa-2x" style="color: rgb(255, 60, 60);" ></em>
            </div>
            <div class="text-lg">{{ 'ROUTES.PAGES.SUPPORTEXPIRED.TITLE' | translate }}</div>
        </div>
        <ul class="list-inline text-center">
            <li class="list-inline-item close-link">
                <a class="text-muted show-pointer" (click)="close()" >{{ 'ROUTES.PAGES.SUPPORTEXPIRED.CLOSE' | translate }}</a>
            </li>
        </ul>
    </div>
</div>

